import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import { ArrowRight, FilePerson, FileText, InfoCircle, BoxArrowRight, Phone, Download, QrCode } from 'react-bootstrap-icons';
import VersionBuild from "../componennts/version_build";
import InfoComponent from "../componennts/info";
import App from "../App";
import ErrorPage from "./error";

function HomePage(props){

    const [showInfo, setShowInfo] = useState(false);
    const showInfoToggle = () => setShowInfo(!showInfo);

    const [filter, setFilter] = useState('all');
    const handleSetFilter = (value) => setFilter(value);

    const projects = [
        {
            name: "Profile",
            desc: "Профайл.",
            url: "/profile",
            icon: <FilePerson size={'28'} />,
            type: "web",
            version: "4.0",
            status: "active",
            color: "success-subtle"
        },
        {
            name: "Profile Passport",
            desc: "Паспорт особи. Blue",
            url: "/profile",
            icon: <FilePerson size={'28'} />,
            type: "web",
            version: "1.0",
            status: "in work",
            color: "warning-subtle"
        },
        {
            name: "Military service certificate",
            desc: "Довідка на військовослужбовця. Black",
            url: "/profile",
            icon: <FilePerson size={'28'} />,
            type: "web",
            version: "1.0",
            status: "todo",
            color: "info-subtle"
        },
        {
            name: "Preliminary Instruction",
            desc: "Попередня інструкція.",
            url: "/profile",
            icon: <FilePerson size={'28'} />,
            type: "web",
            version: "1.0",
            status: "todo",
            color: "info-subtle"
        },
        {
            name: "Questionnaire",
            desc: "Анкета. Політик",
            url: "/profile",
            icon: <FilePerson size={'28'} />,
            type: "web",
            version: "1.0",
            status: "todo",
            color: "info-subtle"
        },
        {
            name: "Information File",
            desc: "Інформаційна довідка про об'єкт.",
            url: "/info-file",
            icon: <FileText size={'28'} />,
            type: "web",
            version: "1.0",
            status: "active",
            color: "success-subtle"
        },
        {
            name: "Factual Statement",
            desc: "Фактологічне викладення. Шаблон.",
            url: "/fact-file",
            icon: <FileText size={'28'} />,
            type: "web",
            version: "1.0",
            status: "new",
            color: "primary-subtle"
        },
        {
            name: "Profile Docx App (Android)",
            desc: "Мабільний  застосунок для перегляду профайлів, пошук, видалення, перегляд по QR коду, поширення профайлів. Авторизація на сайті через QR код та код доступу.",
            url: "/info-file",
            icon: <Phone size={'28'} />,
            type: "app",
            version: "1.0",
            status: "no active",
            color: "danger-subtle"
        }
    ];

    const filterStatus =  [
        {
            label: "Всі",
            status: "all",
            color: "light"
        },
        {
            label: "Нове",
            status: "new",
            color: "primary-subtle"
        },
        {
            label: "В роботі",
            status: "in work",
            color: "warning-subtle"
        },
        {
            label: "Зробити",
            status: "todo",
            color: "info-subtle"
        },
        {
            label: "Активно",
            status: "active",
            color: "success-subtle"
        },
        {
            label: "Не активно",
            status: "no active",
            color: "danger-subtle"
        },

    ];

    if([0, '', null, undefined].includes(localStorage.getItem('uid'))){
        return <ErrorPage />
    }

    return <div id={'home-page'} className={'container d-flex flex-wrap align-items-center justify-content-center'} style={{height: showInfo ? "auto" : "75vh"}}>

        <div className="fixed-top d-flex align-items-center justify-content-between">
            <div className="text-dark d-flex align-items-center p-2">
                <h2>
                    Docx
                </h2>
                <div className="bg-success-subtle text-dark -warning p-1 rounded m-1 mb-2">
                    v6.0
                    {/*<VersionBuild />*/}
                </div>

            </div>

            <div className="menu">
                Вітаю, { localStorage.getItem('name') && <b>{localStorage.getItem('name')}</b> }
                <div className="btn-group">
                    <button type="button" className="btn btn-outline-light border-0 rounded-1" data-bs-toggle="dropdown"
                            aria-expanded="false">
                        <span className="visually-hidden">Toggle Dropdown</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor"
                             className="bi bi-sliders2 text-secondary" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                  d="M10.5 1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4H1.5a.5.5 0 0 1 0-1H10V1.5a.5.5 0 0 1 .5-.5M12 3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m-6.5 2A.5.5 0 0 1 6 6v1.5h8.5a.5.5 0 0 1 0 1H6V10a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5M1 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 8m9.5 2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V13H1.5a.5.5 0 0 1 0-1H10v-1.5a.5.5 0 0 1 .5-.5m1.5 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
                        </svg>
                    </button>
                    <ul className="dropdown-menu">
                        <li><Link className="dropdown-item" to="/info"> <InfoCircle /> Інфорація</Link></li>
                        {/*<li className={'p-1'}>*/}
                        {/*    <button type={'button'} className={'btn btn-light'} onClick={showInfoToggle}>*/}
                        {/*        <InfoCircle /> Інфорація*/}
                        {/*    </button>*/}
                        {/*</li>*/}
                        <li>
                            <hr className="dropdown-divider"/>
                        </li>
                        <li className={'p-1'}>
                            <button type={'button'} className={'btn btn-light text-danger'} onClick={props.exitFunc}>
                                <BoxArrowRight /> Вихід
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {showInfo && <div className={'w-100 text-end pt-5'}>
            <button type={'button'} className={'btn btn-light mt-3'} onClick={showInfoToggle}>
                Закрить
            </button>
            <InfoComponent />
        </div>}

        <div id="projects" className={`${showInfo ? 'd-none' : 'col-md-12 col-12'}`}>
            <small className="text-secondary display-3 opacity-25">
                Проекти
            </small>

            <div id="filter-project" className={'mt-5'}>
                {
                   filterStatus.map((status, index) => <small
                       onClick={() => handleSetFilter(status.status)}
                       className={`bg-${status.color} text-dark p-1 rounded m-1 mb-2 ${status.status === filter && 'border'}`}>
                       {status.label}
                   </small>)
                }
            </div>

            <hr/>
            <div className={`d-flex flex-wrap`}>

                {
                    (filter === 'all' ? projects : projects.filter((a) => a.status === filter)).map((project, i) => <div key={i} className={'col-md-4 col-12 p-1'}>
                        <div className="rounded- p-4 border bg-white">
                            <div className="pb-1">
                                {project.icon}
                                {project.status && <small className={`bg-${project.color} text-dark p-1 rounded m-1 mb-2`}>{project.status}</small>}
                            </div>
                            <h3>
                                {project.name}
                                <small className={'text-secondary mx-1'}>
                                    v{project.version}
                                </small>
                            </h3>
                            <p className={'text-muted'}>
                                {project.desc}
                            </p>
                            {
                                project.type === 'web'
                                    ? <Link to={project.url} className={'btn btn-dark rounded-0'}> <ArrowRight /> відкрить</Link>
                                    : <>
                                        {/*<Link to="/download/profile_docx_app_v1.apk" className={'text-decoration-none m-1'} download>*/}

                                        {/*    <small className="text-secondary">*/}
                                        {/*        <Download /> Android APK*/}
                                        {/*    </small>*/}
                                        {/*</Link>*/}
                                        <div className="qr-tooltip top text-dark m-1">
                                            <QrCode />
                                            <text className="p-2">Завантажить v1.0</text>
                                            <span className="tooltiptext">
                                              <img src=
                                                       "/images/qr_app.png"
                                                   alt="qr_download_app"
                                                   style={{width: '200px', height:'auto'}}
                                              />
                                              <small className={'text-white'}>Скануй QR код для завантаження</small>
                                          </span>
                                        </div>
                                    </>
                            }
                        </div>
                    </div>)
                }

            </div>
        </div>

        {/*<div className="col-md-12">*/}
        {/*    <hr/>*/}
        {/*    <InfoComponent />*/}
        {/*</div>*/}

    </div>

}

export default HomePage;
